import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {
    Breadcrumb,
    Container,
    Header,
    Transition
} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import Plans from "../../components/settings/Plans";
import Prices from "../../components/settings/Prices";
import PaymentData from "../../data/PaymentData";
import {FormattedDate} from "react-intl";
import Loading from "../../components/extras/Loading";
import localDB from "../../data/localDB";

class Suscription extends Component {

    constructor(){
        super();
        this.state = {
            show_prices: false,
            show_plans: true,
            plan: {},
            payment: {
                end_date: Date.now(),
                plan_price:{
                    months: 0,
                    plan:{
                        name:''
                    }
                }
            },
            loading: true,
        };
        this.selectPlan = this.selectPlan.bind(this);
        this.selectBack = this.selectBack.bind(this);
    }

    selectPlan(plan){
        this.setState({show_plans:false, plan});
    }

    selectBack() {
        this.setState({show_prices:false, plan:{}});
    }

    componentDidMount(){
        this.initialFetch();
    }

    async initialFetch(){
        let payment = await PaymentData.getCurrentPlan();
        this.setState({payment, loading:false});
    }

    render() {

        return (
            <div>
                <Helmet>
                    <title>Mi Suscripción | Configuraciones - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    {localDB.checkRolAccess('payments_view') ? <Breadcrumb.Section active>
                        Mi Suscripción - <Link color='orange' to='/settings/suscription/payments'>Ver Pagos Realizados</Link>
                    </Breadcrumb.Section>: 'Mi Suscripción'}
                </Breadcrumb>
                <CustomDivider/>
                <Container>
                    {
                        this.state.loading ?
                            <Loading/>:this.state.payment.plan_price.months ?
                            <Header as='h1'>TU PLAN ACTUAL <span className={'orange'}>
                        {this.state.payment.plan_price.plan.name} x {this.state.payment.plan_price.months} mes(es)
                        </span> CADUCARÁ EL <span className={'orange'}><FormattedDate value={this.state.payment.end_date} />
                    </span>
                            </Header>:<Header as='h1'>TU PLAN ACTUAL <span className={'orange'}> ES GRATIS
                        </span> - NUNCA VENCE, <span className={'orange'}>Actualiza ahora tu plan para una mejor experiencia!
                    </span>
                            </Header>
                    }

                    <Transition visible={this.state.show_plans} animation='scale' onHide={()=>this.setState({show_prices:true})}>
                        <span>
                            <Plans callbackSelectPlan={this.selectPlan}/>
                        </span>
                    </Transition>
                    <Transition visible={this.state.show_prices} animation='scale' onHide={()=>this.setState({show_plans:true})}>
                        <span>
                          <Prices callbackSelectBack={this.selectBack} callbackSelectPrice={this.selectPrice}/>
                        </span>
                    </Transition>
                </Container>
            </div>
        );
    }
}

export default Suscription;



// WEBPACK FOOTER //
// ./src/containers/settings/Suscription.js